import * as React from "react";
import { Link, Paper, styled } from "@mui/material";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import { ReactComponent as CopyLinkIcon } from "../../../../assets/clinic/copyLinkIcon.svg";
import { ReactComponent as PersonalLinkIcon } from "../../../../assets/clinic/personlaLinkIcon.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/clinic/emailIcon.svg";
import { InviteMethods } from "./inviteRouter";
//region [[ Styles ]]

const InviteMethodsMenuView = styled(Paper)({
  padding: 20,
  "& h3": { textAlign: "center", padding: 0, marginBottom: 12 },
});

const MethodButton = styled(Link)({
  marginTop: 8,
  display: "flex",
  gap: 12,
  alignItems: "start",
  padding: 20,
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 14,
  textDecoration: "none",
  border: "1px solid #FFFFFF",
  color: ClinicColors.textMain,
  "&:hover": {
    border: "1px solid " + ClinicColors.borders,
    textDecoration: "none",
  },
  "& .method-icon": {
    flex: "0 0 39px",
  },
  "& h5": {
    fontWeight: 700,
    fontSize: 16,
    padding: 0,
    margin: "0 0 4px 0",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface InviteMethodsMenuProps {
  onSelect: (method: InviteMethods) => void;
}

//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]

export const InviteMethodsMenu = ({ ...props }: InviteMethodsMenuProps) => {
  const handleSelect = (method: InviteMethods) => props.onSelect(method);

  return (
    <InviteMethodsMenuView>
      <h3>Choose Your Method</h3>
      <MethodButton
        className="method-button"
        onClick={() => handleSelect(InviteMethods.Generic)}
      >
        <CopyLinkIcon className="method-icon" />
        <div>
          <h5>Generic Invitation Link</h5>
          Share a link to Kahun's Chatbot with your patients.
        </div>
      </MethodButton>

      <MethodButton
        className="method-button"
        onClick={() => handleSelect(InviteMethods.Personal)}
      >
        <PersonalLinkIcon className="method-icon" />
        <div>
          <h5>Personalized Invitation Link</h5>
          Create a personalized link to Kahun's Chatbot, including patient
          information, to later identify them in your dashboard.
        </div>
      </MethodButton>

      <MethodButton
        className="method-button"
        onClick={() => handleSelect(InviteMethods.List)}
      >
        <EmailIcon className="method-icon" />
        <div>
          <h5>Invitation via Email/SMS</h5>
          Send invitation links to a group of patients directly to their phones
          and/or email addresses.
        </div>
      </MethodButton>
    </InviteMethodsMenuView>
  );
};
